import React from 'react';
const MAIN_PRICE = 16990;
const BUMP_PRICE = 4500;
const BUMP_DISCOUNT = 0.3;
const DISCOUNTED_BUMP = Math.round(BUMP_PRICE * (1 - BUMP_DISCOUNT));
const BUNDLE_PRICE = MAIN_PRICE + DISCOUNTED_BUMP;
const FULL_TOTAL = MAIN_PRICE + BUMP_PRICE;
function fmt(n: number): string {
  return n.toLocaleString('es-AR');
}
interface ExitIntentPopupProps {
  onAccept: () => void;
  onDecline: () => void;
}
export function ExitIntentPopup({
  onAccept,
  onDecline
}: ExitIntentPopupProps) {
  return <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4" data-id="element-33">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onDecline} data-id="element-34" />

      {/* Popup */}
      <div className="popup-enter relative bg-[#1E293B] rounded-[24px] border border-[rgba(34,197,94,0.25)] shadow-[0_32px_80px_rgba(0,0,0,0.6)] max-w-[460px] w-full max-h-[90vh] overflow-y-auto" style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }} data-id="element-35">
        {/* Top gradient line */}
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#22C55E] via-[#F97316] to-transparent rounded-t-[24px]" data-id="element-36" />

        {/* Close button */}
        <button onClick={onDecline} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[rgba(255,255,255,0.06)] flex items-center justify-center text-[#64748B] hover:text-white hover:bg-[rgba(255,255,255,0.12)] transition-all duration-200 z-10" data-id="element-37">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-38">
            <line x1="18" y1="6" x2="6" y2="18" data-id="element-39" />
            <line x1="6" y1="6" x2="18" y2="18" data-id="element-40" />
          </svg>
        </button>

        {/* Header */}
        <div className="px-6 pt-8 pb-4 text-center" data-id="element-41">
          {/* Urgency badge */}
          <div className="badge-flash inline-block bg-[rgba(249,115,22,0.15)] text-[#F97316] border border-[rgba(249,115,22,0.4)] font-montserrat text-[10px] font-extrabold tracking-[2px] uppercase py-1.5 px-4 rounded-full mb-4" data-id="element-42">
            ⚡ OFERTA EXCLUSIVA — SOLO EN ESTA PANTALLA
          </div>

          <h2 className="font-montserrat text-[clamp(20px,4vw,26px)] font-black text-white leading-[1.15] tracking-tight mb-2" data-id="element-43">
            🛑 ¡Esperá! Te estás olvidando
            <br data-id="element-44" />
            algo importante...
          </h2>

          <p className="text-[#94A3B8] text-[14px] leading-[1.6]" data-id="element-45">
            ¿Sabías que podés llevarte{' '}
            <strong className="text-white" data-id="element-46">el paquete completo</strong> con un
            descuento que no vas a encontrar después?
          </p>
        </div>

        {/* Body */}
        <div className="px-6 pb-4" data-id="element-47">
          {/* Discount badge */}
          <div className="badge-flash bg-[#22C55E] text-white font-montserrat text-[14px] font-extrabold tracking-[1px] uppercase py-2.5 px-5 rounded-lg text-center mb-5" data-id="element-48">
            🔥 30% OFF EN EL COMPLEMENTO PERFECTO
          </div>

          {/* Copy */}
          <p className="text-[14px] text-[#94A3B8] leading-[1.7] mb-2" data-id="element-49">
            Llevate{' '}
            <strong className="text-white" data-id="element-50">
              El Método Barrita Pro + la Guía "Mantequilla de Maní Oro Líquido"
            </strong>{' '}
            y fabricá barritas de nivel profesional con la base más cremosa, por
            monedas.
          </p>
          <p className="text-[13px] text-[#64748B] leading-[1.6] mb-5" data-id="element-51">
            El pack incluye el ebook completo, los 6 bonos gratis y la guía de
            mantequilla casera que transforma tus barritas de "ricas" a
            "adictivas".
          </p>

          {/* What's included */}
          <div className="bg-[rgba(15,23,42,0.5)] rounded-xl border border-[rgba(255,255,255,0.06)] p-4 mb-5" data-id="element-52">
            <p className="font-montserrat text-[10px] font-bold uppercase tracking-[1.5px] text-[#94A3B8] mb-3" data-id="element-53">
              Incluido en el paquete completo
            </p>

            <div className="space-y-2" data-id="element-54">
              <div className="flex items-center gap-2.5" data-id="element-55">
                <span className="text-[#22C55E] text-sm" data-id="element-56">✓</span>
                <span className="text-[13px] text-white" data-id="element-57">
                  El Método Barrita Pro — 50+ recetas
                </span>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-58">
                <span className="text-[#22C55E] text-sm" data-id="element-59">✓</span>
                <span className="text-[13px] text-white" data-id="element-60">
                  6 Bonos — Calculadora, Sustitutos, Sin Horno, Veganas,
                  Freezado, Etiquetas
                </span>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-61">
                <span className="text-[#F97316] text-sm" data-id="element-62">★</span>
                <span className="text-[13px] text-[#F97316] font-semibold" data-id="element-63">
                  Guía "Mantequilla de Maní Oro Líquido" — base cremosa en 2 min
                </span>
              </div>
            </div>
          </div>

          {/* Pricing block */}
          <div className="bg-[rgba(34,197,94,0.06)] border border-[rgba(34,197,94,0.2)] rounded-xl p-4 mb-5" data-id="element-64">
            <div className="flex justify-between items-center mb-1" data-id="element-65">
              <span className="text-[13px] text-[#94A3B8]" data-id="element-66">
                Precio por separado:
              </span>
              <span className="text-[15px] text-[#64748B] line-through font-semibold" data-id="element-67">
                ${fmt(FULL_TOTAL)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-68">
              <span className="font-montserrat text-[15px] font-extrabold text-[#22C55E]" data-id="element-69">
                Tu precio especial:
              </span>
              <span className="font-montserrat text-[28px] font-black text-white" data-id="element-70">
                ${fmt(BUNDLE_PRICE)}
              </span>
            </div>
            <div className="flex items-center gap-2 mt-2" data-id="element-71">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-72">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-73" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-74" />
              </svg>
              <span className="text-[11px] text-[#64748B] tracking-[0.3px]" data-id="element-75">
                Precio especial solo disponible en esta pantalla
              </span>
            </div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="px-6 pb-7" data-id="element-76">
          <a href="https://ebookpromax.com/cart/add?id=46723936026782&quantity=1" onClick={() => onAccept()} className="block text-center bg-[#22C55E] text-white font-montserrat text-[14px] font-extrabold uppercase tracking-[1.5px] py-4 px-6 rounded-lg no-underline transition-all duration-[0.25s] hover:bg-[#15803D] hover:shadow-[0_8px_32px_rgba(34,197,94,0.4)] hover:-translate-y-0.5 active:translate-y-0" style={{
          animation: 'pulse-green 2.5s ease infinite'
        }} data-id="element-77">
            SÍ, QUIERO EL PAQUETE COMPLETO POR ${fmt(BUNDLE_PRICE)} &gt;&gt;
          </a>

          <button onClick={onDecline} className="block w-full text-center mt-3 py-3 text-[13px] text-[#64748B] hover:text-[#94A3B8] transition-colors duration-200 bg-transparent border-none cursor-pointer font-medium" data-id="element-78">
            No gracias, continuar sin los extras →
          </button>
        </div>
      </div>
    </div>;
}